import {
  Button,
  Card,
  Collapse,
  ControlGroup,
  Elevation,
  Spinner,
  Tag,
} from "@blueprintjs/core";
import React from "react";
import { apiCallPost } from "../fns/util";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router";
import cogoToast from "cogo-toast";
import AsyncSelWrap from "../utils/AsyncSelWrap";
import PlanSysInv from "../opto/elems/PlanSysInv";

class SysInv extends React.Component {
  state = {
    collapsed: true,
  };
  componentDidMount() {
    this.setState({ ...this.props.data });
  }

  search = async (
    string,
    searchResArray,
    isSearchingShowSpinner,
    selectedItem,
    apiUrl
  ) => {
    if (!string) {
      this.setState({
        [searchResArray]: [],
        [selectedItem]: null,
      });
      return;
    }
    try {
      this.setState({ [isSearchingShowSpinner]: true });
      let payload = { prefix: string || "" };
      let res = await apiCallPost(apiUrl, payload);
      this.setState({
        [searchResArray]: res,
        [isSearchingShowSpinner]: false,
      });
    } catch (err) {
      cogoToast.error(
        "There was an error in searching. Please check the console for more details."
      );
      console.log(err);
    }
  };
  renderAsyncSearchers = (
    tagText,
    placeHolderText,
    stateSearchingKey,
    stateSearchResultsKey,
    stateSelectedItemKey,
    searchApiUrl
  ) => {
    return (
      <ControlGroup>
        <Tag large minimal>
          {tagText}
        </Tag>
        <AsyncSelWrap
          disabled={this.props.isBusy || this.state.isWaitingOnLineItem}
          placeholder={placeHolderText}
          searching={this.state[stateSearchingKey]}
          items={this.state[stateSearchResultsKey].map((each) => {
            return {
              ...each,
              item: each.name,
              entityTypeString: each.email,
              helper: each._id,
            };
          })}
          selectedItem={null}
          update={(string) =>
            this.search(
              string,
              stateSearchResultsKey,
              stateSearchingKey,
              stateSelectedItemKey,
              searchApiUrl
            )
          }
          onChange={(chosenItem) => {
            this.setState({ [stateSelectedItemKey]: chosenItem });
          }}
        />
        {this.state.isWaitingOnLineItem ? <Spinner size={20} /> : null}
      </ControlGroup>
    );
  };

  renderBasedOnLifecycle = () => {
    return (
      <>
        <Collapse isOpen={this.state.collapsed}>
          {" "}
          <Card elevation={Elevation.FOUR}>
            <Tag large intent="primary" style={{ marginBottom: "10px" }}>
              Systemic Parameters
            </Tag>
            <Button
              icon="double-chevron-down"
              outlined
              onClick={() => this.setState({ collapsed: false })}
            />
          </Card>
        </Collapse>{" "}
        <Collapse isOpen={!this.state.collapsed}>
          <Card elevation={Elevation.FOUR} className="dark__bg">
            <ControlGroup style={{ marginBottom: "10px" }}>
              <Tag large fill intent="primary">
                Systemic Parameters
              </Tag>
              <Button
                icon="double-chevron-down"
                outlined
                onClick={() => this.setState({ collapsed: true })}
              />
            </ControlGroup>
            <div
              style={
                this.props.canEdit
                  ? {}
                  : {
                      "pointer-events": "none",
                      opacity: 0.5,
                    }
              }
            >
              <PlanSysInv
                data={this.props.data}
                onUpdate={(data) => this.props.onUpdate(data)}
              />
            </div>
          </Card>
        </Collapse>
      </>
    );
  };
  render() {
    return <div>{this.renderBasedOnLifecycle()}</div>;
  }
}

export default inject("authStore")(observer(withRouter(SysInv)));
